import Link from "next/link";
import getConfig from "next/config";

import FormatedPrice from "@components/Price/FormatedPrice";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ProductPageResealedInfo = ({ resealedList, onResealedClick }) => {
  const resealedCount = resealedList.length;
  const resealedLabel = resealedCount === 1 ? "resigilat" : "resigilate";

  const lowestPrice = resealedList.reduce((cheapest, current) => {
    return parseFloat(current.price.selling_price) < parseFloat(cheapest)
      ? current.price.selling_price
      : cheapest;
  }, resealedList[0].price.selling_price);

  return (
    <div
      className={`${
        isBricoStore ? "text-green" : "bg-[#F0FDF4] text-[#16A34A]"
      } p-[8px] font-medium text-[14px] rounded`}
      onClick={onResealedClick}
    >
      {resealedCount} {resealedLabel}, de la{" "}
      <FormatedPrice price={lowestPrice} currency="lei" />.{" "}
      <Link href="#resigilate">
        <a
          className={`${
            isBricoStore ? "text-orange" : "text-[#1D4ED8]"
          } underline`}
        >
          Vezi {resealedLabel}
        </a>
      </Link>
    </div>
  );
};

export default ProductPageResealedInfo;
